import styled from 'styled-components';

export const Body = styled.div`
    display: grid;
    justify-content: center;
    height: 100%;
    width: 100%;
    background-color: #CE0F2A;
`;
